import { render, staticRenderFns } from "./TotalsApps.vue?vue&type=template&id=428335da&"
import script from "./TotalsApps.vue?vue&type=script&lang=js&"
export * from "./TotalsApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports